export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner le magasin"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sans titre"])}
}